<div [ngStyle]="style">
  <ng-content></ng-content>
</div>
